import { createContext } from 'react';
import { TFunction, i18n } from 'i18next';

interface I18nContextProps {
  t: TFunction;
  i18n: i18n;
}

export const I18nContext = createContext<I18nContextProps | undefined>(undefined);
